import { Injectable, inject } from "@angular/core";
import { catchError, Observable, of, tap } from "rxjs";
import {
    DashboardStatus,
    IDashboardCreateRequest,
    IDashboardCreateResponse,
    IDashboardUpdateResponse,
} from "../../views-interfaces/dashboard-model.interface";
import { ResponseErrorHandlerService } from "../response-error-handler-service/response-error-handler.service";
import { DashboardsService } from "../dashboards-service";
import { IframeMessagesService } from "../iframe-messages-service";

@Injectable()
export class DashboardManagementService {
    private readonly dashboardsService = inject(DashboardsService);
    private readonly iframeMessagesService = inject(IframeMessagesService);
    private readonly responseErrorHandlerService = inject(ResponseErrorHandlerService);

    // TODO: Choose approach betweeen createDashboard and createDashboardPromise and possibly remove the other one.
    // TODO: Replace generic error popups with actual error messages, if applicable.
    createDashboard(dashboardData: IDashboardCreateRequest): Observable<IDashboardCreateResponse> {
        return this.iframeMessagesService
            .postMessageRespObservable<IDashboardCreateRequest, IDashboardCreateResponse>("createDashboard", "dashboardCreated", dashboardData)
            .pipe(
                tap((response) => {
                    if (response.status !== "success") {
                        this.responseErrorHandlerService.showPopup({ typeLayout: "ERROR", messageCode: "defaultError" });
                    }
                }),
                catchError((error) => {
                    console.error("[WK] Error creating dashboard:", error);
                    this.responseErrorHandlerService.showPopup({ typeLayout: "ERROR", messageCode: "defaultError" });
                    return of<IDashboardCreateResponse>({ status: "error" });
                }),
            );
    }

    async createDashboardPromise(dashboardData: IDashboardCreateRequest): Promise<IDashboardCreateResponse> {
        try {
            const response = await this.iframeMessagesService.postMessageResp("createDashboard", { msgId: "", ...dashboardData }, "dashboardCreated");
            if (response.status !== "success") {
                this.responseErrorHandlerService.showPopup({ typeLayout: "ERROR", messageCode: "defaultError" });
            }
            return response;
        } catch (error) {
            console.error("[WK] Error creating dashboard:", error);
            this.responseErrorHandlerService.showPopup({ typeLayout: "ERROR", messageCode: "defaultError" });
            return { status: "error" } as IDashboardCreateResponse;
        }
    }

    deactivateDashboard(dashboardId: string): Observable<IDashboardUpdateResponse> {
        return this.dashboardsService.updateDashboard(dashboardId, { Status: DashboardStatus.Closed }).pipe(
            catchError(() => {
                this.responseErrorHandlerService.showPopup({ typeLayout: "ERROR", messageCode: "defaultError" });
                return of<IDashboardUpdateResponse>({ Code: 0 });
            }),
        );
    }
}
